import {
  BlockControls,
} from '@wordpress/block-editor';
import { ToggleControl } from '@wordpress/components';
import {
  ToolbarButton,
  ToolbarGroup,
  Modal,
  Button,
  TextControl,
  DropdownMenu,
} from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import React from 'react';
import { starFilled } from '@wordpress/icons';
import { ICONS } from '../constants';

interface ControlsProps {
  attributes: {
    icon?: string;
    solid?: boolean;
  };
  setAttributes: (attributes: Record<string, any>) => void;
}

const IconPicker: React.FC<ControlsProps> = ({
  attributes: { icon, solid },
  setAttributes,
}) => {
  const [isSolid, setIsSolid] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState('');

  // Eindeutige Icons filtern
  const filteredIcons = [...new Set(ICONS)].filter((i) =>
    i.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <BlockControls>
        <ToolbarGroup>
          <DropdownMenu
            icon={icon ? <i className={`fa-lg ${icon}`}></i> : starFilled}
            label={__('Icon settings', 'neodigital')}
            controls={[
              {
                title: __('Choose icon', 'neodigital'),
                onClick: () => setModalOpen(true),
              },
              ...(icon
                ? [
                    {
                      title: __('Remove icon', 'neodigital'),
                      onClick: () => setAttributes({ icon: '' }),
                    },
                  ]
                : []),
            ]}
          />
        </ToolbarGroup>
      </BlockControls>
      {isModalOpen && (
        <Modal
          title={__('Select an Icon', 'neodigital')}
          onRequestClose={() => setModalOpen(false)}
        >
          <TextControl
            label={__('Search Icons', 'neodigital')}
            value={search}
            onChange={setSearch}
            placeholder={__('Start typing to filter…', 'neodigital')}
          />


          <div
            style={{
              alignItems: 'start',
              marginTop: '1em',
              overflowY: 'auto',
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(4rem, 1fr))', // ✅ Grid layout
              gap: '10px',
              justifyItems: 'start',
              width: '70vw'
            }}
          >
            {filteredIcons.map((faIcon) => (
              <Button
                key={faIcon}
                variant="tertiary"
                style={{ alignItems: "center", justifyContent: "center", aspectRatio: 1, width: '100%' }}
                onClick={() => {
                  setAttributes({ icon: `fa-solid ${faIcon}`});
                  setModalOpen(false);
                }}
              >
                <i className={`fa-2xl fa ${faIcon}`} style={{ marginRight: 6 }} />
              </Button>
            ))}
          </div>

          {filteredIcons.length === 0 && (
            <p>{__('No icons match your search.', 'neodigital')}</p>
          )}
        </Modal>
      )}
    </>
  );
};

export default IconPicker;
